"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _util = require("@/utils/util");
var _demurrage = require("@/api/query/demurrage");
var _freeTime = require("@/api/query/freeTime");
var _Export2Excel = require("@/utils/Export2Excel");
var _date = require("@/utils/date");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'demurrageAccountSearch',
  data: function data() {
    return {
      ApplyOptions: {
        'DERATE': this.$t('equipmentFee.derate'),
        'REFUND': this.$t('equipmentFee.refund')
      },
      StatusOptions: {
        0: this.$t('equipmentFee.applying'),
        1: this.$t('equipmentFee.approved'),
        2: this.$t('equipmentFee.refuse'),
        6: this.$t('equipmentFee.underApproval')
      },
      dialogTableVisible: false,
      loading: null,
      isCnLang: false,
      activeTab: 'demDetFee',
      form: {
        blNo: ''
      },
      rules: {
        blNo: [{
          required: true,
          message: this.$t('validate.blNo'),
          trigger: 'blur'
        }]
      },
      repairTotal: '',
      repairCurrency: '',
      repairData: [],
      detailInfo: [],
      chargeData: [],
      applyData: [],
      showResult: false,
      showApply: false,
      minioUrl: undefined,
      showDemColumn: true,
      demDetData: [],
      detailLongInfo: [],
      detailSingleInfo: [],
      detailTypeInfo: [],
      dialogFtVisible: false,
      freeTimeType: '',
      detailType: [],
      detailType0: [],
      detailType1: [],
      detailType2: [],
      detailType4: [],
      showDemDet: false,
      demDetTotal: ''
    };
  },
  created: function created() {
    this.minioUrl = this.GLOBAL.MINIO_URL.replace('commerce', 'repairs');
    this.isCnLang = this.$i18n.locale === 'zh';
  },
  methods: {
    validateNull: _validate.validateNull,
    cellStyle: function cellStyle() {
      return 'padding:0px';
    },
    dateFormat: _date.dateFormat,
    columnBackgroundStyle: function columnBackgroundStyle(obj) {
      if (obj.columnIndex === 5) {
        if (obj.row.calculateType2 === 0) {
          return '';
        } else {
          return 'color:red';
        }
      }
    },
    toMoney: _util.toMoney,
    srcListSwith: function srcListSwith(list) {
      var _this = this;
      var imageSrc = [];
      list.forEach(function (i) {
        var src = _this.minioUrl + i.split('|')[1];
        imageSrc.push(src);
      });
      return imageSrc;
    },
    /**
     * 获取修箱费详情
     * @param row
     */
    handle: function handle(row) {
      var _this2 = this;
      (0, _demurrage.repairFeeDetail)({
        blNo: row.blNo,
        containerNo: row.containerNo
      }).then(function (response) {
        _this2.detailInfo = response.data;
        _this2.dialogTableVisible = true;
      });
    },
    /**
     * 获取减免/退费进度
     * @param row
     */
    getProcess: function getProcess() {
      var _this3 = this;
      (0, _demurrage.derateAndRefund)({
        blNo: this.form.blNo
      }).then(function (response) {
        if (!_this3.validateNull(response.data)) {
          _this3.showApply = true;
          _this3.applyData = response.data;
        }
      });
    },
    /**
     * 根据审批号获取对应FT信息
     * @param ftNo
     */
    handleFtNo: function handleFtNo(ftNo) {
      var _this4 = this;
      this.detailLongInfo = [];
      this.detailSingleInfo = [];
      this.detailType = [];
      this.detailType0 = [];
      this.detailType1 = [];
      this.detailType2 = [];
      this.detailType4 = [];
      (0, _freeTime.getFreeTimeInfo)({
        approveNo: ftNo
      }).then(function (response) {
        _this4.freeTimeType = response.data.freeTimeType;
        _this4.detailLongInfo = [response.data];
        _this4.dialogFtVisible = true;
        if (response.data.freeTimeType === 1) {
          (0, _freeTime.getFtContainerInfo)({
            freeTimeId: response.data.freeTimeId
          }).then(function (response) {
            _this4.detailSingleInfo = response.data;
          });
        }
        if (response.data.demurrageType >= 2 || response.data.detentionType >= 2) {
          (0, _freeTime.getFtTypeInfo)({
            freeTimeId: response.data.freeTimeId
          }).then(function (response) {
            var currentData = response.data;
            _this4.detailType = (0, _toConsumableArray2.default)(new Set(currentData.map(function (item) {
              return item.gradeFeeType;
            })));
            var i;
            for (i = 0; i < _this4.detailType.length; i++) {
              if (_this4.detailType[i] === 0) {
                _this4.detailType0 = currentData.filter(function (item) {
                  return item.gradeFeeType === 0;
                });
              } else if (_this4.detailType[i] === 1) {
                _this4.detailType1 = currentData.filter(function (item) {
                  return item.gradeFeeType === 1;
                });
              } else if (_this4.detailType[i] === 2) {
                _this4.detailType2 = currentData.filter(function (item) {
                  return item.gradeFeeType === 2;
                });
              } else if (_this4.detailType[i] === 4) {
                _this4.detailType4 = currentData.filter(function (item) {
                  return item.gradeFeeType === 4;
                });
              }
            }
          });
        }
      });
    },
    /**
     *  DEM&DET费用合计
     **/
    getDemDetSummaries: function getDemDetSummaries(param) {
      var _this5 = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      if (this.showDemColumn === true) {
        columns.forEach(function (column, index) {
          if (index === 9) {
            sums[index] = _this5.$t('equipmentFee.demTotal');
            return;
          }
          if (index === 15) {
            sums[index] = _this5.$t('equipmentFee.detTotal');
            return;
          }
          if (index === 18) {
            sums[index] = _this5.$t('equipmentFee.total');
            return;
          }
          if (index === 10) {
            var currencys = (0, _toConsumableArray2.default)(new Set(data.filter(function (item) {
              return !_this5.validateNull(item.demAmountCurrency);
            }).map(function (item) {
              return item.demAmountCurrency;
            })));
            if (currencys.length === 1) {
              var values = data.map(function (item) {
                return _this5.moneyToNumFiled(item[column.property]);
              });
              sums[index] = (0, _util.toMoney)(values.reduce(function (accumulator, pilot) {
                return accumulator + pilot;
              }, 0));
            } else {
              var currentMoney = [];
              sums[index] = '';
              var i = 0;
              for (i = 0; i < currencys.length; i++) {
                currentMoney[i] = data.filter(function (item) {
                  return item.currency === currencys[i];
                }).map(function (it) {
                  return _this5.moneyToNumFiled(it.demAmount);
                }).reduce(function (accumulator, pilot) {
                  return accumulator + pilot;
                }, 0);
                sums[index] = sums[index] + (0, _util.toMoney)(currentMoney[i]) + '\n(' + currencys[i] + (i === currencys.length - 1 ? ')\n' : ')\n+');
              }
            }
          }
          if (index === 16) {
            var _currencys = (0, _toConsumableArray2.default)(new Set(data.filter(function (item) {
              return !_this5.validateNull(item.detAmountCurrency);
            }).map(function (item) {
              return item.detAmountCurrency;
            })));
            if (_this5.validateNull.apply(_this5, (0, _toConsumableArray2.default)(_currencys))) {
              sums[index] = '';
            } else if (_currencys.length === 1) {
              var _values = data.map(function (item) {
                return _this5.moneyToNumFiled(item[column.property]);
              });
              sums[index] = (0, _util.toMoney)(_values.reduce(function (accumulator, pilot) {
                return accumulator + pilot;
              }, 0));
            } else {
              var _currentMoney = [];
              sums[index] = '';
              var _i = 0;
              for (_i = 0; _i < _currencys.length; _i++) {
                _currentMoney[_i] = data.filter(function (item) {
                  return item.currency === _currencys[_i];
                }).map(function (it) {
                  return _this5.moneyToNumFiled(it.detAmount);
                }).reduce(function (accumulator, pilot) {
                  return accumulator + pilot;
                }, 0);
                sums[index] = sums[index] + (0, _util.toMoney)(_currentMoney[_i]) + '\n(' + _currencys[_i] + (_i === _currencys.length - 1 ? ')\n' : ')\n+');
              }
            }
          }
          if (index === 19) {
            var currencys1 = (0, _toConsumableArray2.default)(new Set(data.filter(function (item) {
              return !_this5.validateNull(item.demAmountCurrency);
            }).map(function (item) {
              return item.demAmountCurrency;
            })));
            var currencys2 = (0, _toConsumableArray2.default)(new Set(data.filter(function (item) {
              return !_this5.validateNull(item.detAmountCurrency);
            }).map(function (item) {
              return item.detAmountCurrency;
            })));
            var _currencys2 = (0, _toConsumableArray2.default)(new Set(currencys1.concat(currencys2)));
            if (_this5.validateNull.apply(_this5, (0, _toConsumableArray2.default)(_currencys2))) {
              sums[index] = '';
            } else if (_currencys2.length === 1) {
              var _values2 = [].concat((0, _toConsumableArray2.default)(data.map(function (item) {
                return _this5.moneyToNumFiled(item.detAmount);
              })), (0, _toConsumableArray2.default)(data.map(function (item) {
                return _this5.moneyToNumFiled(item.demAmount);
              })));
              sums[index] = (0, _util.toMoney)(_values2.reduce(function (accumulator, pilot) {
                return accumulator + pilot;
              }, 0)) + '\n(' + _currencys2[0] + ')';
              _this5.demDetTotal = sums[index];
            } else {
              var _currentMoney2 = [];
              var currentDemMoney = [];
              var currentDetMoney = [];
              sums[index] = '';
              var _i2 = 0;
              for (_i2 = 0; _i2 < _currencys2.length; _i2++) {
                currentDemMoney[_i2] = data.filter(function (item) {
                  return item.currency === _currencys2[_i2];
                }).map(function (it) {
                  return _this5.moneyToNumFiled(it.demAmount);
                }).reduce(function (accumulator, pilot) {
                  return accumulator + pilot;
                }, 0);
                currentDetMoney[_i2] = data.filter(function (item) {
                  return item.currency === _currencys2[_i2];
                }).map(function (it) {
                  return _this5.moneyToNumFiled(it.detAmount);
                }).reduce(function (accumulator, pilot) {
                  return accumulator + pilot;
                }, 0);
                _currentMoney2[_i2] = currentDemMoney[_i2] + currentDetMoney[_i2];
                sums[index] = sums[index] + (0, _util.toMoney)(_currentMoney2[_i2]) + '\n(' + _currencys2[_i2] + (_i2 === _currencys2.length - 1 ? ')\n' : ')\n+');
                _this5.demDetTotal = sums[index];
              }
            }
          }
        });
      } else {
        columns.forEach(function (column, index) {
          if (index === 9) {
            sums[index] = _this5.$t('equipmentFee.detTotal');
            return;
          }
          if (index === 10) {
            var currencys = (0, _toConsumableArray2.default)(new Set(data.filter(function (item) {
              return !_this5.validateNull(item.detAmountCurrency);
            }).map(function (item) {
              return item.detAmountCurrency;
            })));
            if (_this5.validateNull.apply(_this5, (0, _toConsumableArray2.default)(currencys))) {
              sums[index] = '';
            } else if (currencys.length === 1) {
              var values = data.map(function (item) {
                return _this5.moneyToNumFiled(item[column.property]);
              });
              sums[index] = (0, _util.toMoney)(values.reduce(function (accumulator, pilot) {
                return accumulator + pilot;
              }, 0)) + '\n(' + currencys[0] + ')';
              _this5.demDetTotal = sums[index];
            } else {
              var currentMoney = [];
              sums[index] = '';
              var i = 0;
              for (i = 0; i < currencys.length; i++) {
                currentMoney[i] = data.filter(function (item) {
                  return item.currency === currencys[i];
                }).map(function (it) {
                  return _this5.moneyToNumFiled(it.detAmount);
                }).reduce(function (accumulator, pilot) {
                  return accumulator + pilot;
                }, 0);
                sums[index] = sums[index] + (0, _util.toMoney)(currentMoney[i]) + '\n(' + currencys[i] + (i === currencys.length - 1 ? ')\n' : ')\n+');
                _this5.demDetTotal = sums[index];
              }
            }
          }
        });
      }
      return sums;
    },
    /**
     * 查询
     * */
    toSearch: function toSearch() {
      var _this6 = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this6.loading = (0, _utils.load)();
          _this6.resetData();
          _this6.showDemColumn = true;
          _this6.showDemDet = false;
          _this6.showApply = false;
          _this6.getProcess();
          (0, _demurrage.getElectricityCharge)({
            blNo: _this6.form.blNo
          }).then(function (response) {
            if (!_this6.validateNull(response.data.list)) {
              _this6.showResult = true;
              _this6.chargeData = response.data.list;
            }
          });
          (0, _demurrage.searchNew)({
            blNo: _this6.form.blNo
          }).then(function (response) {
            if (!_this6.validateNull(response.data)) {
              _this6.showResult = true;
              var resultData = response.data;
              if (!_this6.validateNull(resultData.list)) {
                //this.showDemDet = true
                _this6.demDetData = response.data.list;
                _this6.showDemColumn = !['CN', 'ID', 'BD', 'MM', 'RU', 'IN'].includes(_this6.demDetData[0].del.substring(0, 2));
              }
              if (!_this6.validateNull(resultData.list3)) {
                _this6.repairData = resultData.list3;
                _this6.repairTotal = (0, _util.toMoney)(resultData.list3[0].totalFee);
                _this6.repairCurrency = resultData.list3[0].targetCurrency;
              }
            }
            if (_this6.validateNull(_this6.demDetData) === false && _this6.validateNull(_this6.repairData) === true) {
              _this6.activeTab = 'demDetFee';
            } else if (_this6.validateNull(_this6.demDetData) === true && _this6.validateNull(_this6.repairData) === false) {
              _this6.activeTab = 'repairFee';
            } else {
              _this6.activeTab = 'demDetFee';
            }
          }).finally(function () {
            _this6.loading.close();
          });
        }
      });
    },
    /**
     *  修箱费合计
     **/
    getSummaries: function getSummaries(param) {
      var _this7 = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      var currentCurrency = '';
      columns.forEach(function (column, index) {
        if (index === 1) {
          var values = data.map(function (item) {
            return item[column.property].replace(/,/g, '');
          });
          currentCurrency = values[0];
          sums[index] = _this7.$t('equipmentFee.total') + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + '  :  ' + _this7.repairTotal + '\xa0\xa0' + values[0];
          return;
        }
        if (index === 2) {
          if (data[0].portCode === 'VNSGN') {
            sums[index] = '(VAT：5%)';
          }
        }
      });
      return sums;
    },
    getChargeSummaries: function getChargeSummaries(param) {
      var _this8 = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 9) {
          sums[index] = _this8.$t('equipmentFee.total');
          return;
        }
        if (index === 10) {
          var values = data.map(function (item) {
            return _this8.moneyToNumFiled(item[column.property]);
          });
          sums[index] = (0, _util.toMoney)(values.reduce(function (accumulator, pilot) {
            return accumulator + pilot;
          }, 0));
          return;
        }
        if (index === 11) {
          var _values3 = data.map(function (item) {
            return _this8.moneyToNumFiled(item[column.property]);
          });
          sums[index] = (0, _util.toMoney)(_values3.reduce(function (accumulator, pilot) {
            return accumulator + pilot;
          }, 0));
          return;
        }
      });
      return sums;
    },
    getDetailSummaries: function getDetailSummaries(param) {
      var _this9 = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 4) {
          sums[index] = _this9.$t('equipmentFee.total');
          return;
        }
        if (index === 5) {
          var values = data.map(function (item) {
            return _this9.moneyToNumFiled(item[column.property]);
          });
          sums[index] = (0, _util.toMoney)(values.reduce(function (accumulator, pilot) {
            return accumulator + pilot;
          }, 0));
          return;
        }
        if (index === 6) {
          var _values4 = data.map(function (item) {
            return item[column.property];
          });
          sums[index] = _values4[0];
        }
      });
      return sums;
    },
    moneyToNumFiled: function moneyToNumFiled(obj) {
      if (obj === null) {
        return 0;
      }
      var ss = obj.toString();
      if (ss.length === 0) {
        return '';
      }
      return isNaN(Number(ss.replace(/,/g, ''))) ? 0 : Number(ss.replace(/,/g, ''));
    },
    /**
     * 表格数据重置
     */
    resetData: function resetData() {
      this.repairTotal = '';
      this.repairCurrency = '';
      this.demDetTotal = '';
      this.repairData = [];
      this.demDetData = [];
      this.chargeData = [];
    },
    /**
     * 导出excel
     */
    exportHandle: function exportHandle() {
      if (this.activeTab === 'demDetFee') {
        if (!this.validateNull(this.demDetData)) {
          (0, _Export2Excel.export_table_to_excel)('#demDetData', 'demDetFee');
        } else {
          this.$message.warning(this.$t('equipmentFee.DEMDETFee') + this.$t('equipmentFee.noData'));
        }
      }
      if (this.activeTab === 'repairFee') {
        if (!this.validateNull(this.repairData)) {
          (0, _Export2Excel.export_table_to_excel)('#repairData', 'repairFee');
        } else {
          this.$message.warning(this.$t('equipmentFee.repairFee') + this.$t('equipmentFee.noData'));
        }
      }
    },
    init: function init() {
      if (!this.validateNull(this.$route.params)) {
        this.form.blNo = this.$route.params.blNo;
        this.toSearch();
      }
      if (!this.validateNull(this.$route.query)) {
        this.form.blNo = this.$route.query.blNo;
        this.toSearch();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
};